import { useState } from "react";

import MotoristaForm from "../../../components/motoristas/form";
import { VerticalContainer } from "../../../components/styled";
import { registerMotorista } from "../../../services/motoristas";
import { registerLocal } from "../../../services/locais";
import LocaisForm from "../../../components/locais/form";

export default function AddLocal(props) {
  const local = props.location.state;

  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const onFinish = async (values) => {
    try {
      setLoading(true);
      return await registerLocal(values);
    } catch (err) {
      setError(err.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <VerticalContainer>
      <div />
      <LocaisForm
        initialValues={local}
        onFinish={onFinish}
        error={error}
        setError={setError}
        loading={loading}
      />
    </VerticalContainer>
  );
}
